import { render } from "./ErrorWrapper.vue?vue&type=template&id=4e82470a"
import script from "./ErrorWrapper.vue?vue&type=script&lang=js"
export * from "./ErrorWrapper.vue?vue&type=script&lang=js"

import "./ErrorWrapper.vue?vue&type=style&index=0&id=4e82470a&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__